export default __webpack_public_path__ + "5fe7f364a4a2e31bb58f789283aa96b8.wav";